// extracted by mini-css-extract-plugin
export default {"app_header":"hA87L-T7BFvwbyJoYJZGOw==","main_nav":"g-M5OUh5bQDFAqvyHeVZhg=="};